import { Component } from '@angular/core';
import { AppService } from '../../../app.service';
import {NgxSmartModalService } from 'ngx-smart-modal';
import translateJson from "../../../../translate.json";

@Component({
    selector: 'error-modal-comp',
    providers: [AppService, NgxSmartModalService],
    templateUrl: './error.modal.component.html',
    styleUrls: ['./error.modal.component.css']
})

export class ErrorModalComponent {
    errorModalData: string[] = ["", "", ""];
    private i18 = translateJson.i18;

    constructor(private appService: AppService, private ngxSmartModalService: NgxSmartModalService){

    }

    /**
     * set error modal data
     */
    public setErrorModalData(array: string[]){
        if(array.length === 3){
            this.errorModalData = array;
        } else {
            this.errorModalData = [this.i18.modals.errorModal.errorHeader, this.i18.modals.errorModal.errorType, this.i18.modals.errorModal.errorMessage];
        }
    }

    public getErrorModalArray() {
        return this.errorModalData;
    }

    public pop(){
        this.ngxSmartModalService.setModalData(this.errorModalData, 'errorModal', true);
        this.ngxSmartModalService.getModal('errorModal').open();
    }
}